import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Camera } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnRicordoPerSempre() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="un-ricordo-per-sempre" className="dark bg-background text-foreground relative min-h-[85vh] w-full overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562462/img/wedding_couple_holding_portrait.png" alt="Sposi che ammirano il loro ritratto analogico" className="h-full w-full object-cover grayscale contrast-125 brightness-90 opacity-60 md:opacity-100" />
        
        {}
        <div className="absolute inset-0 bg-background/20 backdrop-blur-[1px] mix-blend-overlay pointer-events-none" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent md:via-background/40" />
        
        {}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
      </div>

      {}
      <div className="absolute top-0 right-0 w-[50vw] h-[50vh] bg-[radial-gradient(circle_at_top_right,var(--color-amber-600)_0%,transparent_70%)] opacity-20 blur-3xl pointer-events-none mix-blend-screen" />
      <div className="absolute bottom-0 left-0 w-[40vw] h-[40vh] bg-[radial-gradient(circle_at_bottom_left,var(--color-amber-700)_0%,transparent_70%)] opacity-15 blur-3xl pointer-events-none mix-blend-screen" />

      {}
      <div className="container relative z-10 mx-auto px-6 md:px-12">
        <div ref={ref} className={`max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="mb-6 flex items-center gap-3 text-amber-200/80">
            <Camera className="h-5 w-5" strokeWidth={1.5} />
            <span className="text-sm font-medium tracking-widest uppercase">
              Destination Wedding
            </span>
          </div>

          {}
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-foreground mb-8 drop-shadow-lg">Welcome<br /><span className="italic text-amber-100/90">Party</span></h1>

          {}
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-lg mb-10 font-light">A magical experience for your special day. Authentic portraits on analogue paper, developed in the sunlight, to give your guests a timeless emotion.</p>

          {}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="bg-amber-100 text-amber-950 hover:bg-white border-none">
              <Link to="/ContactPage">
                Check Availability
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="border-amber-200/20 text-amber-100 hover:bg-amber-900/20 hover:text-white backdrop-blur-sm">
              <Link to="/WeddingsPage">
                View Details <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}